type ActionHandler = (el: HTMLElement, event: Event) => void;

const clickHandlers: Record<string, ActionHandler> = {};
const inputHandlers: Record<string, ActionHandler> = {};

export function registerAction(name: string, handler: ActionHandler): void {
  clickHandlers[name] = handler;
}

export function registerInputAction(name: string, handler: ActionHandler): void {
  inputHandlers[name] = handler;
}

export function setupGlobalDelegation(root: Element | string = '#app'): void {
  const el = typeof root === 'string' ? document.querySelector(root) : root;
  if (!el) return;

  el.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement).closest<HTMLElement>('[data-action]');
    if (!target) return;

    const action = target.dataset.action;
    if (!action) return;

    try { (window as any).__tapFeedback?.(); } catch (_) {}

    const handler = clickHandlers[action];
    if (handler) handler(target, e);
    else console.warn(`Unknown action: ${action}`);
  });

  el.addEventListener('input', (e) => {
    const target = e.target as HTMLElement;
    const action = target.dataset.inputAction;
    if (!action) return;

    const handler = inputHandlers[action];
    if (handler) handler(target, e);
    else console.warn(`Unknown input action: ${action}`);
  });
}
